import { convertAudioPaginated, convertCollection } from '@core/converters'
import { setCollectionAudios, setCollectionSimple } from '@features/collection'

import { CollectionBands } from './components/collection-bands'
import { CollectionContentLayout } from './components/collection-content-layout/CollectionContentLayout'
import { CollectionHeroContainer } from './containers/CollectionHeroContainer'
import { CollectionAudiosContainer } from './containers/CollectionAudiosContainer'
import { CollectionSuggestionsContainer } from './containers/CollectionSuggestionsContainer'
import type { TCollectionScreenLoaderData } from './types/collectionScreenLoaderTypes'

export const hydrateLoaderData = async (data: TCollectionScreenLoaderData) => {
    const { collection, audios } = data

    setCollectionSimple({
        username: collection.username,
        slug: collection.slug,
        collection: convertCollection(collection),
    })

    if (!audios) {
        return
    }

    setCollectionAudios({
        username: collection.username,
        slug: collection.slug,
        audios: convertAudioPaginated(audios),
    })
}

export const Screen = () => {
    return (
        <CollectionBands hero={<CollectionHeroContainer />}>
            <CollectionContentLayout sidebar={<CollectionSuggestionsContainer />}>
                <CollectionAudiosContainer />
            </CollectionContentLayout>
        </CollectionBands>
    )
}
